import Vue from 'vue'
import Datepicker from 'vuejs-datepicker'

Vue.component('datepicker', Datepicker)



// WEBPACK FOOTER //
// ./src/front/init/components/datepicker.js